import { useQuery } from 'react-query';

import { PaymentService } from '@/api';
import { FilePayment } from '@/api/Payment/getFilePaymentsQuery';

export const UseGetFilePaymentsQuery = 'useGetFilePaymentsQuery';

interface UseGetFilePaymentsQueryArgs {
  fileId?: string;
}

interface UseGetFilePaymentsQueryReturnValue {
  filePayments?: FilePayment[];
  isLoading: boolean;
}

const useGetFilePaymentsQuery = ({
  fileId,
}: UseGetFilePaymentsQueryArgs): UseGetFilePaymentsQueryReturnValue => {
  const { data: filePayments, isLoading } = useQuery(
    [UseGetFilePaymentsQuery, { fileId }],
    async () => {
      if (!fileId) {
        return undefined;
      }
      const response = await PaymentService.getFilePaymentsQuery({ fileId });

      if (response.failure) {
        return undefined;
      }

      return response.value;
    },
    { staleTime: Infinity },
  );

  return { filePayments, isLoading };
};

export default useGetFilePaymentsQuery;
